import { render, staticRenderFns } from "./oldercoin.vue?vue&type=template&id=04a44f16"
import script from "./oldercoin.vue?vue&type=script&lang=js"
export * from "./oldercoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports